import { PersonTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";

export const PersonReducer = (state = {}, action) => {
  let newPerson;

  switch (action.type) {
    case PersonTypes.unset:
      return Object.assign({}, InitialState.createSyncObject());
    case PersonTypes.updatePerson:
      newPerson = Object.assign(
        {}, 
        state.data, 
        {
          person: Object.assign({}, state.data.person, action.person)
        }
      );
      return Object.assign({}, state, {
        data: newPerson,
        lastSync: Date.now()
      });
    case PersonTypes.instagramSet:
      newPerson = Object.assign(
        {}, 
        state.data, 
        {
          insta: action.insta,
          avatar: action.avatar
        }
      );

      return Object.assign({}, state, {
        data: newPerson,
        lastSync: Date.now()
      });
    default:
      return Object.assign({}, state, action.person);
  }
};
